import { useEffect, useState } from 'react'

const THEME_KEY = 'loadboard:theme'
const EVENT = 'loadline:themechange'

const syncHtmlClass = theme => {
	if (typeof document === 'undefined') return
	const root = document.documentElement
	if (theme === 'light') root.classList.add('theme-light')
	else root.classList.remove('theme-light')
}

if (typeof document !== 'undefined') {
	try {
		const initial = localStorage.getItem(THEME_KEY) === 'dark' ? 'dark' : 'light'
		syncHtmlClass(initial)
	} catch {
		syncHtmlClass('light')
	}
}

export default function useGlobalTheme() {
	const [theme, setTheme] = useState(() => {
		try {
			return localStorage.getItem(THEME_KEY) === 'dark' ? 'dark' : 'light'
		} catch {
			return 'light'
		}
	})

	useEffect(() => {
		syncHtmlClass(theme)
	}, [theme])

	useEffect(() => {
		const onChange = e => {
			const next = e?.detail === 'light' || e?.newValue === 'light' ? 'light' : 'dark'
			setTheme(next)
		}
		window.addEventListener(EVENT, onChange)
		window.addEventListener('storage', e => {
			if (e.key === THEME_KEY) onChange(e)
		})
		return () => {
			window.removeEventListener(EVENT, onChange)
		}
	}, [])

	return theme
}

export function broadcastThemeChange(next) {
	try {
		window.dispatchEvent(new CustomEvent(EVENT, { detail: next }))
	} catch {
		// non-fatal if CustomEvent isn't supported
	}
}
